import React from "react";

import peakJobsLogo from "../../assets/images/peak-jobs-logo.svg";

import "./FormCard.scss";

interface FormCardPropsType {
  children: React.ReactNode;
  label?: string;
}

const FormCard = (props: FormCardPropsType) => {
  const { children, label } = props;

  return (
    <div className="FormCard">
      <div className="FormCard__header">
          <img alt="pic" className="FormCard__header-logo" src={peakJobsLogo}/>

        <p className="FormCard__header-title">{label} </p>
      </div>
      <div className="FormCard__container">
        <div className="FormCard__content">{children}</div>
      </div>
    </div>
  );
};

export default FormCard;
